import React, { useState } from "react";

// Components
import MuiHeader from "../../components/MuiHeader";
import PptAssignmentPage from "./PptAssignment.Page";
import TrainingAssignmentPage from "./TrainingAssignment.Page";

import ExtraAssignmentPage from "../ExtraAssignment/ExtraAssignment.Page";

// MUI
import { AppBar, Box, Tabs, Tab, Typography, useTheme } from "@mui/material";
import PropTypes from "prop-types";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
};

function UserAssignmentPage() {
  // ------------------------ Tabs --------------------------
  const theme = useTheme();
  const [tabIndex, setTabIndex] = useState(0);

  const onTabChange = (event, index) => {
    setTabIndex(index);
  };

  const onTabIndexChange = (index) => {
    setTabIndex(index);
  };
  // --------------------------------------------------------

  return (
    <>
      <div>
        <MuiHeader header="User Assignments" />
        <br />
        <br />
        <Box sx={{ bgcolor: "background.paper", width: "100%" }}>
          <AppBar position="static" style={{ background: "#2E3B55" }}>
            <Tabs
              value={tabIndex}
              onChange={onTabChange}
              indicatorColor="primary"
              textColor="inherit"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab label="PPT" {...a11yProps(0)} />
              <Tab label="Training" {...a11yProps(1)} />
              <Tab label="Extra Module" {...a11yProps(2)} />
            </Tabs>
          </AppBar>
          <div
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={tabIndex}
            onChangeIndex={onTabIndexChange}
          >
            <TabPanel value={tabIndex} index={0} dir={theme.direction}>
              <PptAssignmentPage />
            </TabPanel>
            <TabPanel value={tabIndex} index={1} dir={theme.direction}>
              <TrainingAssignmentPage />
            </TabPanel>
            <TabPanel value={tabIndex} index={2} dir={theme.direction}>
              <ExtraAssignmentPage />
            </TabPanel>
          </div>
        </Box>
      </div>
    </>
  );
}

export default UserAssignmentPage;
